// ManageGroupAccess.jsx
// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
// import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Informative.png";
// import ErrorIcon from "../../../Assets/Images/CommanImages/Error.png";
// import { API_BASE_URL } from "../../../Config/Config";

// export default function ManageGroupAccess({
//   dataClient,
//   setMessageBox,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [isOpenDetails, setIsOpenDetails] = useState(true);
//   const [isOpenAddScreens, setIsOpenAddScreens] = useState(true);
//   const [comments, setComments] = useState("");
//   const [isCommentsReadOnly, setIsCommentsReadOnly] = useState(false);

//   const [employeeDetail, setEmployeeDetail] = useState({
//     emp_first_name: "",
//     emp_middle_name: "",
//     emp_last_name: "",
//     emp_id: "",
//     emp_type: "",
//     manager_name: "",
//     designation: "",
//     department: "",
//     status: "",
//     approved_by: "",
//     user_name: "",
//   });

//   const [selectedUserGroups, setSelectedUserGroups] = useState([]);
//   const [userGroupOptions, setUserGroupOptions] = useState([]);
//   const [isUserGroupEnabled, setIsUserGroupEnabled] = useState(false);
//   const [initialSelectedUserGroups, setInitialSelectedUserGroups] = useState([]);
//   const [isDirty, setIsDirty] = useState(false);

//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
//   const UserName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;

//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const staffNum = params.get("MNTStaffNumbr");
//     const userIdFromQuery = params.get("user_id");
//     const commentsFromQuery = params.get("comments");
//     const empIdFromQuery = params.get("emp_id");

//     if (commentsFromQuery) {
//       setComments(commentsFromQuery);
//       setIsCommentsReadOnly(true);
//     }

//     if (staffNum) {
//       (async () => {
//         try {
//           const res = await fetch(
//             `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-employee-by-search-key/?search_key=${encodeURIComponent(
//               staffNum
//             )}`
//           );
//           const data = await res.json();
//           if (Array.isArray(data) && data.length > 0) {
//             const emp = data[0];
//             setEmployeeDetail({
//               emp_first_name: emp.emp_first_name || "",
//               emp_middle_name: emp.emp_middle_name || "",
//               emp_last_name: emp.emp_last_name || "",
//               emp_id: emp.staff_number || "",
//               // emp_id:
//               //   emp.emp_id || emp.employee_id || emp.employeeId || emp.empid || empIdFromQuery || "",
//               emp_type: emp.emp_type || "",
//               manager_name: emp.manager_name || "",
//               designation: emp.designation || "",
//               department: emp.department || "",
//               status: emp.user_status || emp.status || "",
//               approved_by: emp.approved_by || "",
//               user_name: emp.user_name || "",
//             });
//           } else if (empIdFromQuery) {
//             setEmployeeDetail((p) => ({ ...p, emp_id: empIdFromQuery }));
//           }
//         } catch (err) {
//           if (empIdFromQuery) setEmployeeDetail((p) => ({ ...p, emp_id: empIdFromQuery }));
//           console.error("employee fetch error:", err);
//         }
//       })();
//     } else if (empIdFromQuery) {
//       setEmployeeDetail((p) => ({ ...p, emp_id: empIdFromQuery }));
//     }

//     // IMPORTANT: use user_id for this API per your instruction
//     if (userIdFromQuery) {
//       (async () => {
//         try {
//           const res = await fetch(
//             `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-user-group-by-user-id?user_id=${encodeURIComponent(
//               userIdFromQuery
//             )}`,
//             {
//               headers: {
//                 Accept: "application/json",
//                 Authorization: `Bearer ${localStorage.getItem("token")}`,
//               },
//             }
//           );
//           const json = await res.json();
//           if (json && json.status === 200 && Array.isArray(json.data)) {
//             const formatted = json.data.map((g) => ({
//               id: g.user_group_id,
//               label: g.user_group_name,
//               fullData: g,
//             }));
//             setUserGroupOptions(formatted);
//             const ids = json.data.map((g) => g.user_group_id);
//             setSelectedUserGroups(ids);
//             setInitialSelectedUserGroups(ids);
//             setIsDirty(false);
//           }
//         } catch (err) {
//           console.error("get-user-group-by-user-id error:", err);
//         }
//       })();
//     }
//   }, [location.search]);

//   // fetch groups for server-side search
//   // const fetchUserGroups = async (searchKey) => {
//   //   if (!searchKey || searchKey.trim() === "") {
//   //     setUserGroupOptions([]);
//   //     return;
//   //   }
//   //   try {
//   //     const res = await fetch(
//   //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-all-user-groups-search-key?client_branch_id=${clientBranchId}&user_name=${encodeURIComponent(
//   //         UserName
//   //       )}&search_key=${encodeURIComponent(searchKey)}&search_by_screen_report_name=${isUserGroupEnabled}`,
//   //       {
//   //         headers: {
//   //           Accept: "application/json",
//   //           Authorization: `Bearer ${localStorage.getItem("token")}`,
//   //         },
//   //       }
//   //     );
//   //     const json = await res.json();
//   //     if (json && json.status === 200 && Array.isArray(json.data)) {
//   //       const formatted = json.data.map((g) => ({
//   //         id: g.user_group_id,
//   //         label: g.user_group_name,
//   //         fullData: g,
//   //       }));
//   //       setUserGroupOptions(formatted);
//   //     } else {
//   //       setUserGroupOptions([]);
//   //     }
//   //   } catch (err) {
//   //     console.error("fetchUserGroups error:", err);
//   //     setUserGroupOptions([]);
//   //   }
//   // };

//   // fetch groups for server-side search
//   const fetchUserGroups = async (searchKey) => {
//     // If searchKey is empty, do nothing (preserve existing options and selections)
//     if (!searchKey || searchKey.trim() === "") {
//       return;
//     }

//     try {
//       const res = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-all-user-groups-search-key?client_branch_id=${clientBranchId}&user_name=${encodeURIComponent(
//           UserName
//         )}&search_key=${encodeURIComponent(searchKey)}&search_by_screen_report_name=${isUserGroupEnabled}`,
//         {
//           headers: {
//             Accept: "application/json",
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
//       const json = await res.json();
//       if (json && json.status === 200 && Array.isArray(json.data)) {
//         const formatted = json.data.map((g) => ({
//           id: g.user_group_id,
//           label: g.user_group_name,
//           fullData: g,
//         }));

//         // Merge new results with existing options: new first, then keep previous non-duplicates
//         setUserGroupOptions((prev = []) => {
//           const map = new Map();
//           // add new results first
//           formatted.forEach((item) => map.set(String(item.id), item));
//           // append previous options if they aren't in the new set
//           prev.forEach((p) => {
//             if (!map.has(String(p.id))) map.set(String(p.id), p);
//           });

//           // Ensure any currently selected items are present even if they were not in prev or formatted
//           //(This protects the table when selectedUserGroups contains ids not returned by search)
//           (selectedUserGroups || []).forEach((selId) => {
//             const key = String(selId);
//             if (!map.has(key)) {
//               // try to find the object in prev (already checked), otherwise create a minimal placeholder
//               const foundInPrev = prev.find((p) => String(p.id) === key);
//               if (foundInPrev) {
//                 map.set(key, foundInPrev);
//               } else {
//                 // placeholder so the table can render something for the selected id
//                 map.set(key, { id: selId, label: `Group ${selId}`, fullData: { user_group_id: selId } });
//               }
//             }
//           });

//           return Array.from(map.values());
//         });
//       } else {
//         // No results: keep existing options (don't wipe them) but you may want to show a visual "no results"
//         // We'll just leave options unchanged to avoid dropping selected ones.
//         // setUserGroupOptions([]); // <-- removed so we don't clear existing options
//       }
//     } catch (err) {
//       console.error("fetchUserGroups error:", err);
//       // Keep previous options on error rather than clearing them
//     }
//   };


//   const headers = [
//     "User Group ID",
//     "User Group Name",
//     "Description",
//     "Group Owner Name",
//   ];

//   const tableData = selectedUserGroups.map((id) => {
//     const opt = userGroupOptions.find((o) => o.id === id);
//     if (!opt) return [id, "---", "---", "---"];
//     const d = opt.fullData;
//     return [id, d.user_group_name || "---", d.user_group_desc || "---", d.group_owner_name || "---"];
//   });

//   useEffect(() => {
//     const a = new Set(initialSelectedUserGroups);
//     const b = new Set(selectedUserGroups);
//     const equal = a.size === b.size && [...a].every((x) => b.has(x));
//     setIsDirty(!equal);
//   }, [selectedUserGroups, initialSelectedUserGroups]);

//   const handleSaveUser = async () => {
//     if (!employeeDetail.emp_id || !comments.trim()) {
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX"><div className="messagebox-insider1"><div className="loader-tc"></div><span>Please provide Employee & Comments</span></div></div>
//       );
//       setActiveImg(ErrorIcon);
//       return;
//     }
//     if (String(employeeDetail.status).toLowerCase() === "inactive") return;

//     const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/update-app-user-groups?emp_id=${encodeURIComponent(
//       employeeDetail.emp_id
//     )}&user_name=${encodeURIComponent(UserName || "")}&comments=${encodeURIComponent(comments)}&client_id=${encodeURIComponent(clientId || "")}`;

//     try {
//       const resp = await fetch(url, {
//         method: "PUT",
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//         body: JSON.stringify(selectedUserGroups),
//       });
//       const json = await resp.json();
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX"><div className="messagebox-insider1"><div className="loader-tc"></div><span>{json.message}</span></div></div>
//       );
//       setActiveImg(InterogativeImg);
//       setInitialSelectedUserGroups([...selectedUserGroups]);
//       setIsDirty(false);
//     } catch (err) {
//       console.error("save error:", err);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX"><div className="messagebox-insider1"><div className="loader-tc"></div><span>Something went wrong</span></div></div>
//       );
//       setActiveImg(ErrorIcon);
//     }
//   };

//   const groupsLocked =
//     !!employeeDetail.status && String(employeeDetail.status).toLowerCase() === "inactive";

//   // ====== The dim color to copy from "User Information" area ======
//   // We'll mirror its opacity (0.45) and also apply the same background tint
//   // by using a slightly transparent white background so it visually matches.
//   // You can tweak the rgba to exactly match your FormInputs disabled look.
//   const contentDimStyle = groupsLocked
//     ? { opacity: 0.45, pointerEvents: "none", backgroundColor: "rgba(255,255,255,0.5)" }
//     : {};

//   // But since DropdownWithPagination manages its own disabling when isDisabled is passed,
//   // we pass isDisabled to it as well so the input gets disabled internally.
//   // Also pass a style to make its wrapper match the same opacity (visual parity).
//   const dropdownStyleWhenLocked = groupsLocked ? { opacity: 0.45 } : {};

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Application User - Group Access</span>
//         <div className="cr-header-btn-container">
//           <button className="cr-cancel-btn" onClick={() => navigate("/user_dashboard")}>CANCEL</button>
//           <button
//             className="cr-create-btn"
//             onClick={handleSaveUser}
//             disabled={!isDirty || groupsLocked}
//             style={{
//               opacity: !groupsLocked && isDirty ? 1 : 0.45,
//               cursor: !groupsLocked && isDirty ? "pointer" : "not-allowed",
//             }}
//           >
//             SAVE
//           </button>
//         </div>
//       </div>

//       {/* USER INFORMATION */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header"><label>USER INFORMATION</label></div>
//           <div className="accordion-btn" onClick={() => setIsOpenDetails(!isOpenDetails)}>
//             {isOpenDetails ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenDetails && (
//           <div className="accordion-content">
//             <div className="select-assign-test-container-ques-pap-del" style={{ padding: "10px 60px 20px 20px" }}>
//               <div className="grid-container-ques-paper-del">
//                 <FormInputs label="User Name" value={employeeDetail.user_name} readOnly disabled />
//                 <FormInputs label="Employee Name" value={`${employeeDetail.emp_first_name} ${employeeDetail.emp_middle_name} ${employeeDetail.emp_last_name}`} readOnly disabled />
//                 <FormInputs label="Employee ID" value={employeeDetail.emp_id} readOnly disabled />
//                 <FormInputs label="Department" value={employeeDetail.department} readOnly disabled />
//                 <FormInputs label="Designation" value={employeeDetail.designation} readOnly disabled />
//                 <FormInputs label="Manager Name" value={employeeDetail.manager_name || "N/A"} readOnly disabled />
//                 <FormInputs label="User Status" value={employeeDetail.status} readOnly disabled />
//                 <FormInputs label="Application Access" value={employeeDetail.emp_type} readOnly disabled />
//                 <FormInputs label="Approved By" value={employeeDetail.approved_by} readOnly disabled />

//                 <div style={{ gridColumn: "1 / -1" }}>
//                   <FormInputs
//                     label="Comments"
//                     value={comments}
//                     readOnly={isCommentsReadOnly}
//                     disabled={isCommentsReadOnly}
//                     onChange={(e) => setComments(e.target.value)}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* USER GROUPS header remains visible and clickable */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header"><label>USER GROUPS</label></div>
//           <div className="accordion-btn" onClick={() => setIsOpenAddScreens(!isOpenAddScreens)}>
//             {isOpenAddScreens ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {/* ONLY the content area is dimmed & non-interactive; header stays fully visible */}
//         {isOpenAddScreens && (
//           <div className="accordion-content" style={groupsLocked ? { opacity: 1 } : {}}>
//             <div className="select-assign-test-container-ques-pap-del"  style={{ padding: "20px 0px 20px 0px" }}>
//               <div className="grid-container-ques-paper-del">

//                 {/* Dropdown: pass isDisabled so internal input gets disabled (prevents click),
//                     and also pass style to match dim color/opacity of User Information area. */}
//                 <div style={{ gridColumn: "1 / -1", ...(groupsLocked ? { opacity: 0.45 } : {}), marginLeft: "20px" }}>
//                   <DropdownWithPagination
//                     label="Search User Group"
//                     width="31%"
//                     selected={selectedUserGroups}
//                     setSelected={setSelectedUserGroups}
//                     onSearchInputChange={fetchUserGroups}
//                     options={userGroupOptions}
//                     showSelectAll={false}
//                     allowMultiple={true}
//                     itemsPerPage={4}
//                     placeholder="Type User Group Name"
//                     showLabelCheckbox={true}
//                     labelCheckboxChecked={isUserGroupEnabled}
//                     onLabelCheckboxChange={setIsUserGroupEnabled}
//                     labelCheckboxText="Search by Screen/Report Name"
//                     isDisabled={groupsLocked}                 // <= crucial: tells component to disable input & root
//                     style={dropdownStyleWhenLocked}           // <= visual parity (opacity)
//                   />
//                 </div>

//                 {/* Table area: we don't modify the table component; instead dim & block pointer events
//                     on its immediate wrapper so clicks won't reach it. */}
//                 <div
//                   style={{
//                     gridColumn: "1 / -1",
//                     ...(groupsLocked ? { opacity: 0.45, pointerEvents: "none" } : {}),
//                   }}
//                 >
//                   <TableWithCrossStudentGroup
//                     headers={headers}
//                     data={tableData}
//                     selectedRows={selectedUserGroups}
//                     setSelectedRows={setSelectedUserGroups}
//                     handleDeleteRow={() => {}}
//                     searchPlaceholder="Search user groups..."
//                     renderQuestionText={(t) => t}
//                     renderQuestionTextModel={(t) => t}
//                     expandedStates={{}}
//                     toggleImage={() => {}}
//                     pageType="userEdit"
//                   />
//                 </div>

//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }































// ManageGroupAccess.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import InterogativeImg from "../../../Assets/Images/CommanImages/Informative.png";
import ErrorIcon from "../../../Assets/Images/CommanImages/Error.png";
import { API_BASE_URL } from "../../../Config/Config";
import EndPoints from "../../../Api/Endpoints";

export default function ManageGroupAccess({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const [isOpenDetails, setIsOpenDetails] = useState(true);
  const [isOpenAddScreens, setIsOpenAddScreens] = useState(true);
  const [comments, setComments] = useState("");
  const [isCommentsReadOnly, setIsCommentsReadOnly] = useState(false);

  // employeeDetail holds displayable personal details (names, designation, etc.)
  // IMPORTANT: employeeDetail.emp_id WILL hold the actual internal emp_id (NOT staff_number)
  const [employeeDetail, setEmployeeDetail] = useState({
    emp_first_name: "",
    emp_middle_name: "",
    emp_last_name: "",
    emp_id: "", // actual emp_id (for API)
    emp_type: "",
    manager_name: "",
    designation: "",
    department: "",
    status: "",
    approved_by: "",
    user_name: "",
  });

  // Keep staff number separate (this is what we display in "Employee ID" field)
  const [staffNumber, setStaffNumber] = useState("");
  // Also keep fallback empId from query if provided
  const [empIdFromQueryState, setEmpIdFromQueryState] = useState("");

  const [selectedUserGroups, setSelectedUserGroups] = useState([]);
  const [userGroupOptions, setUserGroupOptions] = useState([]);
  const [isUserGroupEnabled, setIsUserGroupEnabled] = useState(false);
  const [initialSelectedUserGroups, setInitialSelectedUserGroups] = useState([]);
  const [isDirty, setIsDirty] = useState(false);

  const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
  const UserName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;

   const accessToken = localStorage.getItem("other");

  // helper: return true if a group is allowed (active and not default)
  const isAllowedGroup = (g) => {
    if (!g) return false;
    const status = String(g.status || "").toLowerCase();
    const defaultFlag = String(g.default_group || "").toLowerCase();
    if (status === "inactive") return false;
    if (defaultFlag === "true") return false;
    return true;
  };

  // -----------------------
  // Parse URL params ONCE on mount / location.search change
  // -----------------------
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const staffNum = params.get("MNTStaffNumbr");
    const userIdFromQuery = params.get("user_id");
    const commentsFromQuery = params.get("comments");
    const empIdFromQuery = params.get("emp_id");

    if (commentsFromQuery) {
      setComments(commentsFromQuery);
      setIsCommentsReadOnly(true);
    }

    // if staff number present: call get-employee-by-search-key with staff number (search_key)
    if (staffNum) {
      setStaffNumber(String(staffNum));
      (async () => {
       try {
        const res = await fetch(
          `${EndPoints.PRISM_GET_EMPLOYEE_BY_SEARCH_KEY}?search_key=${encodeURIComponent(staffNum)}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        const result = await res.json();

        // ✅ Updated according to new response structure
        if (result?.data && result.data.length > 0) {
          const emp = result.data[0];

            // emp.emp_id might be in different keys depending on backend; pick best match
            const actualEmpId =
              emp.emp_id ||
              emp.employee_id ||
              emp.employeeId ||
              emp.empid ||
              emp.empId ||
              emp.id ||
              "";

            setEmployeeDetail({
              emp_first_name: emp.emp_first_name || "",
              emp_middle_name: emp.emp_middle_name || "",
              emp_last_name: emp.emp_last_name || "",
              emp_id: actualEmpId ? String(actualEmpId) : "",
              emp_type: emp.emp_type || "",
              manager_name: emp.manager_name || "",
              designation: emp.designation || "",
              department: emp.department || "",
              status: emp.user_status || emp.status || "",
              approved_by: emp.approved_by || "",
              user_name: emp.user_name || "",
            });

            // staff_number is often a separate field
            if (emp.staff_number !== undefined && emp.staff_number !== null && String(emp.staff_number).trim() !== "") {
              setStaffNumber(String(emp.staff_number));
            }
          } else {
            // no employee found using staffNum
            if (empIdFromQuery) {
              // use emp_id from query if provided
              setEmployeeDetail((p) => ({ ...p, emp_id: String(empIdFromQuery) }));
              setEmpIdFromQueryState(String(empIdFromQuery));
            }
          }
        } catch (err) {
          console.error("employee fetch error:", err);
          if (empIdFromQuery) {
            setEmployeeDetail((p) => ({ ...p, emp_id: String(empIdFromQuery) }));
            setEmpIdFromQueryState(String(empIdFromQuery));
          }
        }
      })();
    } else if (empIdFromQuery) {
      // no staffNum provided, but emp_id passed in query
      setEmployeeDetail((p) => ({ ...p, emp_id: String(empIdFromQuery) }));
      setEmpIdFromQueryState(String(empIdFromQuery));
    }

    // IMPORTANT: use user_id for fetching user groups
    if (userIdFromQuery) {
      (async () => {
        try {
          const res = await fetch(
            `${EndPoints.PRISM_GET_USER_GROUP_BY_USER_ID}?user_id=${encodeURIComponent(
              userIdFromQuery
            )}`,
            {
              headers: {
                Accept: "application/json",
                Authorization: `Bearer ${localStorage.getItem("other")}`,
              },
            }
          );
          const json = await res.json();
          if (json && json.status === 200 && Array.isArray(json.data)) {
            // Filter out inactive and default_group:true entries from the results
            const filtered = json.data.filter(isAllowedGroup);

            const formatted = filtered.map((g) => ({
              id: g.user_group_id,
              label: g.user_group_name,
              fullData: g,
            }));

            setUserGroupOptions(formatted);

            const ids = formatted.map((g) => g.id);
            setSelectedUserGroups(ids);
            setInitialSelectedUserGroups(ids);
            setIsDirty(false);
          }
        } catch (err) {
          console.error("error:", err);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  // -----------------------
  // fetchUserGroups (server-side search) - keep old behavior but filter results
  // - do NOT remove previously selected IDs that become disallowed
  // -----------------------
  const fetchUserGroups = async (searchKey) => {
    if (!searchKey || searchKey.trim() === "") {
      return;
    }

    try {
      const res = await fetch(
        `${EndPoints.PRISM_GET_ALL_USER_GROUPS_SEARCH_KEY}?client_branch_id=${clientBranchId}&user_name=${encodeURIComponent(UserName
        )}&search_key=${encodeURIComponent(searchKey)}&search_by_screen_report_name=${isUserGroupEnabled}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const json = await res.json();
      if (json && json.status === 200 && Array.isArray(json.data)) {
        // Filter out groups where status === "Inactive" OR default_group === "True"
        const formatted = json.data
          .filter((g) => isAllowedGroup(g))
          .map((g) => ({
            id: g.user_group_id,
            label: g.user_group_name,
            fullData: g,
          }));

        // Merge new allowed results with existing options; keep existing options (so dropdown behaves as before).
        setUserGroupOptions((prev = []) => {
          const map = new Map();
          // add new results first (only allowed ones)
          formatted.forEach((item) => map.set(String(item.id), item));
          // append previous options if they aren't in the new set (keep old ones as-is)
          prev.forEach((p) => {
            if (!map.has(String(p.id))) map.set(String(p.id), p);
          });

          // Ensure any currently selected items are present even if they were not in prev or formatted.
          // This preserves previously selected IDs (we do NOT remove disallowed previously selected IDs).
          (selectedUserGroups || []).forEach((selId) => {
            const key = String(selId);
            if (!map.has(key)) {
              const foundInPrev = prev.find((p) => String(p.id) === key);
              if (foundInPrev) {
                map.set(key, foundInPrev);
              } else {
                // placeholder so the table can render something for the selected id
                map.set(key, { id: selId, label: `Group ${selId}`, fullData: { user_group_id: selId } });
              }
            }
          });

          return Array.from(map.values());
        });
      } else {
        // keep existing options — do not clear
      }
    } catch (err) {
      console.error("fetchUserGroups error:", err);
      // keep previous options on error
    }
  };

  // -------- Table helpers & derived data ----------
  const headers = ["User Group ID", "User Group Name", "Description", "Group Owner Name"];

  const tableData = selectedUserGroups.map((id) => {
    const opt = userGroupOptions.find((o) => String(o.id) === String(id));
    if (!opt) return [id, "---", "---", "---"];
    const d = opt.fullData || {};
    return [id, d.user_group_name || "---", d.user_group_desc || "---", d.group_owner_name || "---"];
  });

  // isDirty = true if selectedUserGroups differs from initialSelectedUserGroups
  useEffect(() => {
    const a = new Set(initialSelectedUserGroups || []);
    const b = new Set(selectedUserGroups || []);
    const equal = a.size === b.size && [...a].every((x) => b.has(x));
    setIsDirty(!equal);
  }, [selectedUserGroups, initialSelectedUserGroups]);

  // ---------- Save handler: send actual emp_id (NOT staffNumber) ----------
  const handleSaveUser = async () => {
    // choose actual emp id to send: prefer employeeDetail.emp_id, fallback to empIdFromQueryState
    const actualEmpIdToSend = (employeeDetail.emp_id && String(employeeDetail.emp_id).trim()) || empIdFromQueryState || "";

    if (!actualEmpIdToSend || !comments.trim()) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please provide Employee & Comments</span>
          </div>
        </div>
      );
      setActiveImg(ErrorIcon);
      return;
    }

    if (String(employeeDetail.status).toLowerCase() === "inactive") return;

    const url = `${EndPoints.PRISM_UPDATE_APP_USER_GROUPS}?emp_id=${encodeURIComponent(
      actualEmpIdToSend
    )}&user_name=${encodeURIComponent(UserName || "")}&comments=${encodeURIComponent(comments)}&client_id=${encodeURIComponent(clientId || "")}`;

    try {
      const resp = await fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("other")}`,
        },
        body: JSON.stringify(selectedUserGroups),
      });

      // parse response safely
      const json = await resp.json().catch(() => ({ status: resp.status, message: resp.statusText }));

      // Only treat as success if backend returned success (status === 200)
      if (json && (json.status === 200 || String(json.status) === "200")) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{json.message || "Saved successfully"}</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);

        // only update "initialSelectedUserGroups" and clear dirty flag on success
        setInitialSelectedUserGroups([...selectedUserGroups]);
        setIsDirty(false);
      } else {
        // treat as failure — do not flip initialSelectedUserGroups or isDirty
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{(json && json.message) || "Save failed"}</span>
            </div>
          </div>
        );
        setActiveImg(ErrorIcon);
      }
    } catch (err) {
      console.error("save error:", err);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Something went wrong</span>
          </div>
        </div>
      );
      setActiveImg(ErrorIcon);
    }
  };

  // ====== new handler passed to TableWithCrossStudentGroup ======
  // Accepts id (user_group_id) and removes it from selectedUserGroups.
  // We intentionally do NOT remove the option from userGroupOptions — this keeps the dropdown behavior stable.
  const handleDeleteRow = (id) => {
    if (id === undefined || id === null) return;
    setSelectedUserGroups((prev) => prev.filter((x) => String(x) !== String(id)));
    // we don't update initialSelectedUserGroups here; the isDirty effect will run and update the button state.
  };

  const groupsLocked =
    !!employeeDetail.status && String(employeeDetail.status).toLowerCase() === "inactive";

  const dropdownStyleWhenLocked = groupsLocked ? { opacity: 0.45 } : {};

  // Display Employee ID should show staffNumber (preferred), else actual emp_id
  const displayEmployeeId = staffNumber || employeeDetail.emp_id || empIdFromQueryState || "";

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Application User - Group Access</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={() => navigate("/user_dashboard")}>CANCEL</button>
          <button
            className="cr-create-btn"
            onClick={handleSaveUser}
            // Save is disabled only when there's no change (not dirty) OR groups are locked
            disabled={!isDirty || groupsLocked}
            style={{
              opacity: !groupsLocked && isDirty ? 1 : 0.45,
              cursor: !groupsLocked && isDirty ? "pointer" : "not-allowed",
            }}
          >
            SAVE
          </button>
        </div>
      </div>

      {/* USER INFORMATION */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header"><label>USER INFORMATION</label></div>
          <div className="accordion-btn" onClick={() => setIsOpenDetails(!isOpenDetails)}>
            {isOpenDetails ? <div className="minus"></div> : <div className="plus">+</div>}
          </div>
        </div>

        {isOpenDetails && (
          <div className="accordion-content">
            <div className="select-assign-test-container-ques-pap-del" style={{ padding: "10px 60px 20px 20px" }}>
              <div className="grid-container-ques-paper-del">
                <FormInputs label="User Name" value={employeeDetail.user_name} readOnly disabled />
                {/* <FormInputs label="Employee Name" value={`${employeeDetail.emp_first_name} ${employeeDetail.emp_middle_name} ${employeeDetail.emp_last_name}`} readOnly disabled /> */}
                <FormInputs label="Employee Name" value={`${employeeDetail.emp_last_name}, ${employeeDetail.emp_middle_name} ${employeeDetail.emp_first_name}`} readOnly disabled />
                {/* Employee ID now shows staffNumber (preferred). The actual emp_id is kept separately and used for API calls */}
                <FormInputs label="Employee ID" value={displayEmployeeId || "-NA-"} readOnly disabled />
                <FormInputs label="Department" value={employeeDetail.department || "-NA-"} readOnly disabled />
                <FormInputs label="Designation" value={employeeDetail.designation || "-NA-"} readOnly disabled />
                <FormInputs label="Manager Name" value={employeeDetail.manager_name || "-NA-"} readOnly disabled />
                <FormInputs label="User Status" value={employeeDetail.status || "-NA-"} readOnly disabled />
                <FormInputs label="Application Access" value={employeeDetail.emp_type || "-NA-"} readOnly disabled />
                <FormInputs label="Approved By" value={employeeDetail.approved_by || "-NA-"} readOnly disabled />

                <div style={{ gridColumn: "1 / -1" }}>
                  <FormInputs
                    label="Comments"
                    value={comments}
                    readOnly={isCommentsReadOnly}
                    disabled={isCommentsReadOnly}
                    onChange={(e) => setComments(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* USER GROUPS header remains visible and clickable */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header"><label>USER GROUPS</label></div>
          <div className="accordion-btn" onClick={() => setIsOpenAddScreens(!isOpenAddScreens)}>
            {isOpenAddScreens ? <div className="minus"></div> : <div className="plus">+</div>}
          </div>
        </div>

        {isOpenAddScreens && (
          <div className="accordion-content" style={groupsLocked ? { opacity: 1 } : {}}>
            <div className="select-assign-test-container-ques-pap-del" style={{ padding: "20px 0px 20px 0px" }}>
              <div className="grid-container-ques-paper-del">

                <div style={{ gridColumn: "1 / -1", ...(groupsLocked ? { opacity: 0.45 } : {}), marginLeft: "20px" }}>
                  <DropdownWithPagination
                    label="Search User Group"
                    width="31%"
                    selected={selectedUserGroups}
                    setSelected={setSelectedUserGroups}
                    onSearchInputChange={fetchUserGroups}
                    options={userGroupOptions}
                    showSelectAll={false}
                    allowMultiple={true}
                    itemsPerPage={4}
                    placeholder="Type User Group Name"
                    showLabelCheckbox={true}
                    labelCheckboxChecked={isUserGroupEnabled}
                    onLabelCheckboxChange={setIsUserGroupEnabled}
                    labelCheckboxText="Search by Screen/Report Name"
                    isDisabled={groupsLocked}
                    style={dropdownStyleWhenLocked}
                  />
                </div>

                <div
                  style={{
                    gridColumn: "1 / -1",
                    ...(groupsLocked ? { opacity: 0.45, pointerEvents: "none" } : {}),
                  }}
                >
                  <TableWithCrossStudentGroup
                    headers={headers}
                    data={tableData}
                    selectedRows={selectedUserGroups}
                    setSelectedRows={setSelectedUserGroups}
                    handleDeleteRow={handleDeleteRow} 
                    searchPlaceholder="Search user groups..."
                    renderQuestionText={(t) => t}
                    renderQuestionTextModel={(t) => t}
                    expandedStates={{}}
                    toggleImage={() => {}}
                    pageType="userEdit"
                  />
                </div>

              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
